"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRoleQryViewModel = instanceOfRoleQryViewModel;
exports.RoleQryViewModelFromJSON = RoleQryViewModelFromJSON;
exports.RoleQryViewModelFromJSONTyped = RoleQryViewModelFromJSONTyped;
exports.RoleQryViewModelToJSON = RoleQryViewModelToJSON;
exports.RoleQryViewModelToJSONTyped = RoleQryViewModelToJSONTyped;
/**
 * Check if a given object implements the RoleQryViewModel interface.
 */
function instanceOfRoleQryViewModel(value) {
    return true;
}
function RoleQryViewModelFromJSON(json) {
    return RoleQryViewModelFromJSONTyped(json, false);
}
function RoleQryViewModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'ugNo': json['ugNo'] == null ? undefined : json['ugNo'],
        'selectedUgNos': json['selectedUgNos'] == null ? undefined : json['selectedUgNos'],
    };
}
function RoleQryViewModelToJSON(json) {
    return RoleQryViewModelToJSONTyped(json, false);
}
function RoleQryViewModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'ugNo': value['ugNo'],
        'selectedUgNos': value['selectedUgNos'],
    };
}
